import React, { forwardRef, useEffect, useState } from "react";
import Container from "@mui/material/Container";
import Web3 from 'web3';
import logo from "../../../../../assets/images/logo.png";
import wallet from "../../../../../assets/images/wallet.png";
import styled from "@emotion/styled";

import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { P } from "../../../../Styles/style";
const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const Wrapper = styled.div`
display:flex;
align-items: center;
justify-content: space-between;
padding: 20px 0;
`
const ConnectButt = styled.button`
display:flex;
align-items: center;
background-color: transparent;
border: 1px solid #fff;
color: #fff;
padding: 10px 20px;
border-radius: 10px;
font-size: 16px;
`
const Navbar = ({ onBalanceUpdate }) => {
  const [web3, setWeb3] = useState(null);
  const [account, setAccount] = useState(null);
  const [getAddress, setAddress] = useState('connecting');
  const [chainId, setChainId] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [getUserBalance, setUserBalance] = useState('');

  const [error, setError] = useState('');
  const [OpenError, setOpenError] = useState(false);
  const [Open, setOpen] = useState(false);
  const connectWallet = async () => {
    if (chainId !== '0x171') {
      setOpenError(true);
      setError('Invalid Network. Please Switch to the PulseChain network.');
      return;
    }
    try {
      await window.ethereum.request({ method: 'eth_requestAccounts' });
    } catch (error) {
      console.error(error);
    }
  };

  const handleNetworkChange = async (chainId) => {
    console.log("Network changed", chainId);
    setChainId(chainId);
    if (chainId !== '0x171') {
      setOpen(true);
      console.log("Invalid Network. Please connect to the correct network.");
      setErrorMessage("Invalid Network. Please Switch to the PulseChain network.");
      setWeb3(null);
      setAccount(null);
    } else {
      // Chain ID is valid, reinitialize Web3 and retrieve accounts
      const web3 = new Web3(window.ethereum);
      const accounts = await web3.eth.getAccounts();
      // userAdr(account);
      setWeb3(web3);
      setAccount(accounts[0]);
      setErrorMessage('');
    }
  };

  useEffect(() => {
    

  }, [web3, account]);

  useEffect(() => {
    const initWeb3 = async () => {
      if (window.ethereum) {
        try {
          const web3 = new Web3(window.ethereum);
          const network = await window.ethereum.request({ method: 'eth_chainId' });
          setChainId(network);
          // Check the chain ID
          if (network === '0x171') { // Use the 'network' variable instead of 'chainId'
            const accounts = await web3.eth.getAccounts();
            setWeb3(web3);
            setAccount(accounts[0]);
          } else {
            setWeb3(null);
            setAccount(null);
          }
        } catch (error) {
          console.error(error);
        }
      } else {
        console.log('Please install MetaMask!');
      }
    };

    initWeb3();
    const handleAccountsChanged = (accounts) => {
      if (accounts.length === 0) {
        setAccount(null);
      } else {
        setAccount(accounts[0]);
      }
    };

    if (window.ethereum) {
      window.ethereum.on('accountsChanged', handleAccountsChanged);
      window.ethereum.on('chainChanged', handleNetworkChange);
    }

    return () => {
      if (window.ethereum) {
        window.ethereum.removeListener('accountsChanged', handleAccountsChanged);
        window.ethereum.removeListener('chainChanged', handleNetworkChange);
      }
    };
  }, []);

  useEffect(() => {
    if (account) setAddress(`${account.slice(0, 4)}...${account.substr(38 - 0)}`)
  }, [account]);


  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };
  const handleCloseError = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenError(false);
  };
  return (
    <div>
        <Snackbar open={OpenError} autoHideDuration={2000} onClose={handleCloseError}>
        <Alert onClose={handleCloseError} severity="error" sx={{ width: '100%' }}>
          <>{error}</>
        </Alert>
      </Snackbar>
       <Snackbar open={Open} autoHideDuration={5000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
          {errorMessage && <>{errorMessage}</>}
          </Alert>
        </Snackbar>
      <Container maxWidth="xl">
        <Wrapper>
          <a style={{ textDecoration: "none" }} href="/">
            <img alt="logo" src={logo} />
          </a>
          <div>
            {account ? (
              <>
                <ConnectButt><img src={wallet} />&nbsp;{getAddress}&nbsp;</ConnectButt>
              </>
            ) : (
              <ConnectButt onClick={connectWallet}> <img src={wallet} />&nbsp;Connect wallet </ConnectButt>
            )}
          </div>
        </Wrapper>
      </Container>
    </div>
  );


};
export default Navbar;
